import React, { useMemo, useState } from 'react'
import { Icon, Label, Popup } from 'semantic-ui-react'
import _ from 'lodash'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import { ScheduleCalendar } from '../calendar/Calendar'

export const PopupDrop = ({ ddOptions, fip, items }) => {

  const { propname, label: caption, value: items_selected, onChange } = fip ?? {}

  const [isOpen, setIsOpen] = useState(false)

  const joinUntilLimit = (arr = [], opts = [], charLimit = 50, separator = ', ') => {
    const result = _.reduce(
      arr,
      (acc, item) => {
        const _item = _.find(opts, { key: item })
        const next = acc.text
          ? `${acc.text}${separator}${_item?.text || item}`
          : _item?.text || item;

        if (next.length > charLimit) {
          acc.hidden++;
          acc.truncated = true;
        } else if (!acc.truncated) {
          acc.text = next;
        } else {
          acc.hidden++;
        }

        return acc;
      },
      { text: '', hidden: 0, truncated: false }
    );

    return result.hidden
      ? `${result.text} (+${result.hidden})`
      : result.text;
  };

  const options = useMemo(() => {
    return ddOptions || _.map(items, item => (
      {
        text: _.startCase(item),
        key: item,
        value: item
      }))
  }, [items, ddOptions])

  const { optionIssues, items_selected_unique, displayCaption } = useMemo(() => {
    return {
      optionIssues: _.size(_.uniq(items_selected)) !== _.size(items_selected),
      items_selected_unique: _.uniq(items_selected),
      displayCaption: joinUntilLimit(_.uniq(items_selected), options)
    }
  }, [items_selected, options])

  const handleDups = (e) => {
    e.stopPropagation()
    const data = { propname, value: items_selected_unique, options }
    onChange(null, data)
  }

  // if (optionIssues) {
  //   console.log('options', options)
  // }

  const trigger = <div className='field'>
    <label>{caption || 'Prop Name'}</label>
    <div style={{
      width: '100%',
      display: 'flex',
      rowGap: '.5em',
      justifyContent: 'space-between',
      backgroundColor: 'var(--off-black-2)',
      border: '1px solid var(--off-black-4)',
      borderRadius: '4px',
      padding: '.25em',
      alignItems: 'baseline'
    }}>
      <div style={{ display: 'flex', columnGap: '.5em', alignItems: 'center' }}>
        <Label
          size='tiny'
          color={_.isEmpty(items_selected) ? 'grey' : optionIssues ? 'red' : 'blue'}
          style={{ margin: '.5em', cursor: 'pointer' }}
          title={JSON.stringify(items_selected, null, 2)}
          onClick={(e) => { optionIssues && handleDups(e) }}
        >
          {`${_.size(items_selected_unique)}`}
        </Label>
        <div style={{ fontSize: '.8rem' }}>{displayCaption}</div>
      </div>
      <Icon
        name={isOpen ? 'angle down' : 'angle right'}
        style={{ marginLeft: '1em', cursor: 'pointer' }}
        onClick={(e) => {
          setIsOpen(true)
        }}
      />
    </div>
  </div>

  const fnAlt = (item) => {
    const { key } = item
    const _selected = _.includes(items_selected_unique, key)
    return <Icon
      name={_selected ? 'check circle outline' : 'circle outline'}
      color={_selected ? 'green' : 'grey'}
    />
  }

  const toggleItem = (arr, item) =>
    _.includes(arr, item)
      ? _.without(arr, item)
      : [...arr, item]

  const content_ims = () => {
    const hc = (item) => {
      const _selected = toggleItem(items_selected_unique || [], item.key)
      const data = { propname, value: _selected, options }
      onChange(null, data)
    }
    return <ItemMenuSquares
      menuItems={_.sortBy(options, 'text')}
      imsType={_imsTypes.inline}
      fn_altContent={fnAlt}
      noItemIcon={true}
      onClick={hc}
      style={{ maxHeight: '200px', overflowY: 'auto' }}
    />
  }

  const content_popup = () => <div style={{ display: 'flex', flexDirection: 'column', gap: '.5em', width: '100%' }}>{content_ims()}</div>
  // const cal_popup = () => {
  //   const handleDateSelect = () => { }
  //   const inputDate = 'Thursday, June 18, 2026'
  //   const props = { fip, handleDateSelect, inputDate, itemProp: { key: 'startDate', display: { caption: 'Start Date' } } }
  //   return <ScheduleCalendar handleDateSelect={handleDateSelect} inputDate={inputDate} {...props} />
  // }

  const popup = useMemo(() => {
    return <Popup
      content={content_popup()}
      on='click'
      pinned
      position='bottom left'
      basic
      size='tiny'
      style={{ backgroundColor: 'var(--off-black-4)', color: 'white', borderColor: 'var(--off-black-5)' }}
      trigger={trigger}
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
    // closeOnDocumentClick
    />
  }, [items_selected_unique, ddOptions, isOpen])

  return popup
}
